import { render, staticRenderFns } from "./CompetitorsPrice.vue?vue&type=template&id=041cb1a9&scoped=true"
import script from "./CompetitorsPrice.vue?vue&type=script&lang=ts"
export * from "./CompetitorsPrice.vue?vue&type=script&lang=ts"
import style0 from "./CompetitorsPrice.vue?vue&type=style&index=0&id=041cb1a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041cb1a9",
  null
  
)

export default component.exports